import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { BigNumber } from '@ethersproject/bignumber';
import { JsonRpcProvider } from '@ethersproject/providers';
import DEFAULT_TOKEN_LIST from '@uniswap/default-token-list';
import { Protocol, SwapRouter } from '@uniswap/router-sdk';
import { Fraction, TradeType } from '@uniswap/sdk-core';
import { Pool, Position, SqrtPriceMath, TickMath } from '@uniswap/v3-sdk';
import retry from 'async-retry';
import JSBI from 'jsbi';
import _ from 'lodash';
import NodeCache from 'node-cache';
import { CachingGasStationProvider, CachingTokenProviderWithFallback, CachingV2SubgraphProvider, CachingV3PoolProvider, CachingV3SubgraphProvider, EIP1559GasPriceProvider, ETHGasStationInfoProvider, LegacyGasPriceProvider, NodeJSCache, OnChainGasPriceProvider, StaticV2SubgraphProvider, StaticV3SubgraphProvider, SwapRouterProvider, UniswapMulticallProvider, URISubgraphProvider, V2QuoteProvider, V2SubgraphProviderWithFallBacks, V3SubgraphProviderWithFallBacks } from '../../providers';
import { CachingTokenListProvider } from '../../providers/caching-token-list-provider';
import { TokenProvider } from '../../providers/token-provider';
import { TokenValidationResult, TokenValidatorProvider } from '../../providers/token-validator-provider';
import { V2PoolProvider } from '../../providers/v2/pool-provider';
import { ArbitrumGasDataProvider, OptimismGasDataProvider } from '../../providers/v3/gas-data-provider';
import { V3PoolProvider } from '../../providers/v3/pool-provider';
import { V3QuoteProvider } from '../../providers/v3/quote-provider';
import { ChainId, ID_TO_CHAIN_ID, ID_TO_NETWORK_NAME, V2_SUPPORTED } from '../../util/chains';
import { log } from '../../util/log';
import { buildSwapMethodParameters, buildTrade } from '../../util/methodParameters';
import { metric, MetricLoggerUnit } from '../../util/metric';
import { poolToString, routeToString } from '../../util/routes';
import { UNSUPPORTED_TOKENS } from '../../util/unsupported-tokens';
import { SwapToRatioStatus } from '../router';
import { DEFAULT_ROUTING_CONFIG_BY_CHAIN, ETH_GAS_STATION_API_URL } from './config';
import { V2RouteWithValidQuote, V3RouteWithValidQuote } from './entities/route-with-valid-quote';
import { getBestSwapRoute } from './functions/best-swap-route';
import { calculateRatioAmountIn } from './functions/calculate-ratio-amount-in';
import { computeAllV2Routes, computeAllV3Routes } from './functions/compute-all-routes';
import { getV2CandidatePools, getV3CandidatePools } from './functions/get-candidate-pools';
import { V2HeuristicGasModelFactory } from './gas-models/v2/v2-heuristic-gas-model';
import { V3HeuristicGasModelFactory } from '.';
export var AlphaRouter = /*#__PURE__*/function () {
  function AlphaRouter(_ref) {
    var chainId = _ref.chainId,
        provider = _ref.provider,
        multicall2Provider = _ref.multicall2Provider,
        v3PoolProvider = _ref.v3PoolProvider,
        v3QuoteProvider = _ref.v3QuoteProvider,
        v2PoolProvider = _ref.v2PoolProvider,
        v2QuoteProvider = _ref.v2QuoteProvider,
        v2SubgraphProvider = _ref.v2SubgraphProvider,
        tokenProvider = _ref.tokenProvider,
        blockedTokenListProvider = _ref.blockedTokenListProvider,
        v3SubgraphProvider = _ref.v3SubgraphProvider,
        gasPriceProvider = _ref.gasPriceProvider,
        v3GasModelFactory = _ref.v3GasModelFactory,
        v2GasModelFactory = _ref.v2GasModelFactory,
        swapRouterProvider = _ref.swapRouterProvider,
        optimismGasDataProvider = _ref.optimismGasDataProvider,
        tokenValidatorProvider = _ref.tokenValidatorProvider,
        arbitrumGasDataProvider = _ref.arbitrumGasDataProvider;

    _classCallCheck(this, AlphaRouter);

    this.chainId = chainId;
    this.provider = provider;
    this.multicall2Provider = multicall2Provider !== null && multicall2Provider !== void 0 ? multicall2Provider : new UniswapMulticallProvider(chainId, provider, 375000);
    this.v3PoolProvider = v3PoolProvider !== null && v3PoolProvider !== void 0 ? v3PoolProvider : new CachingV3PoolProvider(this.chainId, new V3PoolProvider(ID_TO_CHAIN_ID(chainId), this.multicall2Provider), new NodeJSCache(new NodeCache({
      stdTTL: 360,
      useClones: false
    })));

    if (v3QuoteProvider) {
      this.v3QuoteProvider = v3QuoteProvider;
    } else {
      switch (chainId) {
        case ChainId.OPTIMISM:
        case ChainId.OPTIMISTIC_KOVAN:
          this.v3QuoteProvider = new V3QuoteProvider(chainId, provider, this.multicall2Provider, {
            retries: 2,
            minTimeout: 100,
            maxTimeout: 1000
          }, {
            multicallChunk: 110,
            gasLimitPerCall: 1200000,
            quoteMinSuccessRate: 0.1
          }, {
            gasLimitOverride: 3000000,
            multicallChunk: 45
          }, {
            gasLimitOverride: 3000000,
            multicallChunk: 45
          }, {
            baseBlockOffset: -10,
            rollback: {
              enabled: true,
              attemptsBeforeRollback: 1,
              rollbackBlockOffset: -10
            }
          });
          break;

        case ChainId.ARBITRUM_ONE:
        case ChainId.ARBITRUM_RINKEBY:
          this.v3QuoteProvider = new V3QuoteProvider(chainId, provider, this.multicall2Provider, {
            retries: 2,
            minTimeout: 100,
            maxTimeout: 1000
          }, {
            multicallChunk: 10,
            gasLimitPerCall: 12000000,
            quoteMinSuccessRate: 0.1
          }, {
            gasLimitOverride: 30000000,
            multicallChunk: 6
          }, {
            gasLimitOverride: 30000000,
            multicallChunk: 6
          });
          break;

        case ChainId.CELO:
        case ChainId.CELO_ALFAJORES:
          this.v3QuoteProvider = new V3QuoteProvider(chainId, provider, this.multicall2Provider, {
            retries: 2,
            minTimeout: 100,
            maxTimeout: 1000
          }, {
            multicallChunk: 10,
            gasLimitPerCall: 5000000,
            quoteMinSuccessRate: 0.1
          }, {
            gasLimitOverride: 5000000,
            multicallChunk: 5
          }, {
            gasLimitOverride: 6250000,
            multicallChunk: 4
          });
          break;

        default:
          this.v3QuoteProvider = new V3QuoteProvider(chainId, provider, this.multicall2Provider, {
            retries: 2,
            minTimeout: 100,
            maxTimeout: 1000
          }, {
            multicallChunk: 210,
            gasLimitPerCall: 705000,
            quoteMinSuccessRate: 0.15
          }, {
            gasLimitOverride: 2000000,
            multicallChunk: 70
          });
          break;
      }
    }

    this.v2PoolProvider = v2PoolProvider !== null && v2PoolProvider !== void 0 ? v2PoolProvider : new V2PoolProvider(chainId, this.multicall2Provider);
    this.v2QuoteProvider = v2QuoteProvider !== null && v2QuoteProvider !== void 0 ? v2QuoteProvider : new V2QuoteProvider();
    this.blockedTokenListProvider = blockedTokenListProvider !== null && blockedTokenListProvider !== void 0 ? blockedTokenListProvider : new CachingTokenListProvider(chainId, UNSUPPORTED_TOKENS, new NodeJSCache(new NodeCache({
      stdTTL: 3600,
      useClones: false
    })));
    this.tokenProvider = tokenProvider !== null && tokenProvider !== void 0 ? tokenProvider : new CachingTokenProviderWithFallback(chainId, new NodeJSCache(new NodeCache({
      stdTTL: 3600,
      useClones: false
    })), new CachingTokenListProvider(chainId, DEFAULT_TOKEN_LIST, new NodeJSCache(new NodeCache({
      stdTTL: 3600,
      useClones: false
    }))), new TokenProvider(chainId, this.multicall2Provider));
    var chainName = ID_TO_NETWORK_NAME(chainId); // ipfs urls in the following format: `https://cloudflare-ipfs.com/ipns/api.uniswap.org/v1/pools/${protocol}/${chainName}.json`;

    if (v2SubgraphProvider) {
      this.v2SubgraphProvider = v2SubgraphProvider;
    } else {
      this.v2SubgraphProvider = new V2SubgraphProviderWithFallBacks([new CachingV2SubgraphProvider(chainId, new URISubgraphProvider(chainId, "https://cloudflare-ipfs.com/ipns/api.uniswap.org/v1/pools/v2/".concat(chainName, ".json"), undefined, 0), new NodeJSCache(new NodeCache({
        stdTTL: 300,
        useClones: false
      }))), new StaticV2SubgraphProvider(chainId)]);
    }

    if (v3SubgraphProvider) {
      this.v3SubgraphProvider = v3SubgraphProvider;
    } else {
      this.v3SubgraphProvider = new V3SubgraphProviderWithFallBacks([new CachingV3SubgraphProvider(chainId, new URISubgraphProvider(chainId, "https://cloudflare-ipfs.com/ipns/api.uniswap.org/v1/pools/v3/".concat(chainName, ".json"), undefined, 0), new NodeJSCache(new NodeCache({
        stdTTL: 300,
        useClones: false
      }))), new StaticV3SubgraphProvider(chainId, this.v3PoolProvider)]);
    }

    this.gasPriceProvider = gasPriceProvider !== null && gasPriceProvider !== void 0 ? gasPriceProvider : new CachingGasStationProvider(chainId, this.provider instanceof JsonRpcProvider ? new OnChainGasPriceProvider(chainId, new EIP1559GasPriceProvider(this.provider), new LegacyGasPriceProvider(this.provider)) : new ETHGasStationInfoProvider(ETH_GAS_STATION_API_URL), new NodeJSCache(new NodeCache({
      stdTTL: 15,
      useClones: false
    })));
    this.v3GasModelFactory = v3GasModelFactory !== null && v3GasModelFactory !== void 0 ? v3GasModelFactory : new V3HeuristicGasModelFactory();
    this.v2GasModelFactory = v2GasModelFactory !== null && v2GasModelFactory !== void 0 ? v2GasModelFactory : new V2HeuristicGasModelFactory();
    this.swapRouterProvider = swapRouterProvider !== null && swapRouterProvider !== void 0 ? swapRouterProvider : new SwapRouterProvider(this.multicall2Provider);

    if (chainId == ChainId.OPTIMISM || chainId == ChainId.OPTIMISTIC_KOVAN) {
      this.l2GasDataProvider = optimismGasDataProvider !== null && optimismGasDataProvider !== void 0 ? optimismGasDataProvider : new OptimismGasDataProvider(chainId, this.multicall2Provider);
    }

    if (chainId == ChainId.ARBITRUM_ONE || chainId == ChainId.ARBITRUM_RINKEBY) {
      this.l2GasDataProvider = arbitrumGasDataProvider !== null && arbitrumGasDataProvider !== void 0 ? arbitrumGasDataProvider : new ArbitrumGasDataProvider(chainId, this.provider);
    }

    if (tokenValidatorProvider) {
      this.tokenValidatorProvider = tokenValidatorProvider;
    } else if (this.chainId == ChainId.MAINNET) {
      this.tokenValidatorProvider = new TokenValidatorProvider(this.chainId, this.multicall2Provider, new NodeJSCache(new NodeCache({
        stdTTL: 30000,
        useClones: false
      })));
    }
  }

  _createClass(AlphaRouter, [{
    key: "routeToRatio",
    value: function () {
      var _routeToRatio = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(token0Balance, token1Balance, position, swapAndAddConfig, swapAndAddOptions) {
        var _this = this;

        var routingConfig,
            _ref2,
            preSwapOptimalRatio,
            zeroForOne,
            _ref3,
            _ref4,
            inputBalance,
            outputBalance,
            optimalRatio,
            postSwapTargetPool,
            exchangeRate,
            swap,
            ratioAchieved,
            n,
            _loop,
            _ret,
            methodParameters,
            _args2 = arguments;

        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                routingConfig = _args2.length > 5 && _args2[5] !== undefined ? _args2[5] : DEFAULT_ROUTING_CONFIG_BY_CHAIN(this.chainId);

                if (token1Balance.currency.wrapped.sortsBefore(token0Balance.currency.wrapped)) {
                  _ref2 = [token1Balance, token0Balance];
                  token0Balance = _ref2[0];
                  token1Balance = _ref2[1];
                }

                preSwapOptimalRatio = this.calculateOptimalRatio(position, position.pool.sqrtRatioX96, true); // set up parameters according to which token will be swapped

                if (position.pool.tickCurrent > position.tickUpper) {
                  zeroForOne = true;
                } else if (position.pool.tickCurrent < position.tickLower) {
                  zeroForOne = false;
                } else {
                  zeroForOne = new Fraction(token0Balance.quotient, token1Balance.quotient).greaterThan(preSwapOptimalRatio);
                  if (!zeroForOne) preSwapOptimalRatio = preSwapOptimalRatio.invert();
                }

                _ref3 = zeroForOne ? [token0Balance, token1Balance] : [token1Balance, token0Balance], _ref4 = _slicedToArray(_ref3, 2), inputBalance = _ref4[0], outputBalance = _ref4[1];
                optimalRatio = preSwapOptimalRatio;
                postSwapTargetPool = position.pool;
                exchangeRate = zeroForOne ? position.pool.token0Price : position.pool.token1Price;
                swap = null;
                ratioAchieved = false;
                n = 0; // iterate until we find a swap with a sufficient ratio or return null

                _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                  var amountToSwap, inputBalanceUpdated, outputBalanceUpdated, newRatio, targetPoolPriceUpdate;
                  return _regeneratorRuntime().wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          n++;

                          if (!(n > swapAndAddConfig.maxIterations)) {
                            _context.next = 4;
                            break;
                          }

                          log.info('max iterations exceeded');
                          return _context.abrupt("return", {
                            v: {
                              status: SwapToRatioStatus.NO_ROUTE_FOUND,
                              error: 'max iterations exceeded'
                            }
                          });

                        case 4:
                          amountToSwap = calculateRatioAmountIn(optimalRatio, exchangeRate, inputBalance, outputBalance);

                          if (!amountToSwap.equalTo(0)) {
                            _context.next = 8;
                            break;
                          }

                          log.info("no swap needed: amountToSwap = 0");
                          return _context.abrupt("return", {
                            v: {
                              status: SwapToRatioStatus.NO_SWAP_NEEDED
                            }
                          });

                        case 8:
                          _context.next = 10;
                          return _this.route(amountToSwap, outputBalance.currency, TradeType.EXACT_INPUT, undefined, _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_ROUTING_CONFIG_BY_CHAIN(_this.chainId)), routingConfig), {}, {
                            protocols: [Protocol.V3, Protocol.V2]
                          }));

                        case 10:
                          swap = _context.sent;

                          if (swap) {
                            _context.next = 14;
                            break;
                          }

                          log.info('no route found from this.route()');
                          return _context.abrupt("return", {
                            v: {
                              status: SwapToRatioStatus.NO_ROUTE_FOUND,
                              error: 'no route found'
                            }
                          });

                        case 14:
                          inputBalanceUpdated = inputBalance.subtract(swap.trade.inputAmount);
                          outputBalanceUpdated = outputBalance.add(swap.trade.outputAmount);
                          newRatio = inputBalanceUpdated.divide(outputBalanceUpdated);
                          targetPoolPriceUpdate = void 0;
                          swap.route.forEach(function (route) {
                            if (route.protocol == Protocol.V3) {
                              var v3Route = route;
                              v3Route.route.pools.forEach(function (pool, i) {
                                if (pool.token0.equals(position.pool.token0) && pool.token1.equals(position.pool.token1) && pool.fee == position.pool.fee) {
                                  targetPoolPriceUpdate = JSBI.BigInt(v3Route.sqrtPriceX96AfterList[i].toString());
                                  optimalRatio = _this.calculateOptimalRatio(position, JSBI.BigInt(targetPoolPriceUpdate.toString()), zeroForOne);
                                }
                              });
                            }
                          });

                          if (!targetPoolPriceUpdate) {
                            optimalRatio = preSwapOptimalRatio;
                          }

                          ratioAchieved = newRatio.equalTo(optimalRatio) || _this.absoluteValue(newRatio.asFraction.divide(optimalRatio).subtract(1)).lessThan(swapAndAddConfig.ratioErrorTolerance);

                          if (ratioAchieved && targetPoolPriceUpdate) {
                            postSwapTargetPool = new Pool(position.pool.token0, position.pool.token1, position.pool.fee, targetPoolPriceUpdate, position.pool.liquidity, TickMath.getTickAtSqrtRatio(targetPoolPriceUpdate), position.pool.tickDataProvider);
                          }

                          exchangeRate = swap.trade.outputAmount.divide(swap.trade.inputAmount);
                          log.info({
                            exchangeRate: exchangeRate.asFraction.toFixed(18),
                            optimalRatio: optimalRatio.asFraction.toFixed(18),
                            newRatio: newRatio.asFraction.toFixed(18),
                            inputBalanceUpdated: inputBalanceUpdated.asFraction.toFixed(18),
                            outputBalanceUpdated: outputBalanceUpdated.asFraction.toFixed(18),
                            ratioErrorTolerance: swapAndAddConfig.ratioErrorTolerance.toFixed(18),
                            iterationN: n.toString()
                          }, 'QuoteToRatio Iteration Parameters');

                          if (!exchangeRate.equalTo(0)) {
                            _context.next = 27;
                            break;
                          }

                          log.info('exchangeRate to 0');
                          return _context.abrupt("return", {
                            v: {
                              status: SwapToRatioStatus.NO_ROUTE_FOUND,
                              error: 'insufficient liquidity to swap to optimal ratio'
                            }
                          });

                        case 27:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop);
                });

              case 12:
                if (ratioAchieved) {
                  _context2.next = 19;
                  break;
                }

                return _context2.delegateYield(_loop(), "t0", 14);

              case 14:
                _ret = _context2.t0;

                if (!(typeof _ret === "object")) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt("return", _ret.v);

              case 17:
                _context2.next = 12;
                break;

              case 19:
                if (swap) {
                  _context2.next = 21;
                  break;
                }

                return _context2.abrupt("return", {
                  status: SwapToRatioStatus.NO_ROUTE_FOUND,
                  error: 'no route found'
                });

              case 21:
                if (!swapAndAddOptions) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 24;
                return this.buildSwapAndAddMethodParameters(swap.trade, swapAndAddOptions, {
                  initialBalanceTokenIn: inputBalance,
                  initialBalanceTokenOut: outputBalance,
                  preLiquidityPosition: position
                });

              case 24:
                methodParameters = _context2.sent;

              case 25:
                return _context2.abrupt("return", {
                  status: SwapToRatioStatus.SUCCESS,
                  result: _objectSpread(_objectSpread({}, swap), {}, {
                    methodParameters: methodParameters,
                    optimalRatio: optimalRatio,
                    postSwapTargetPool: postSwapTargetPool
                  })
                });

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, this);
      }));

      function routeToRatio(_x, _x2, _x3, _x4, _x5) {
        return _routeToRatio.apply(this, arguments);
      }

      return routeToRatio;
    }()
    /**
     * @inheritdoc IRouter
     */

  }, {
    key: "route",
    value: function () {
      var _route = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(amount, quoteCurrency, tradeType, swapConfig) {
        var partialRoutingConfig,
            _a,
            blockNumber,
            routingConfig,
            protocols,
            currencyIn,
            currencyOut,
            tokenIn,
            tokenOut,
            _this$getAmountDistri,
            _this$getAmountDistri2,
            percents,
            amounts,
            beforeGas,
            _yield$this$gasPriceP,
            gasPriceWei,
            quoteToken,
            quotePromises,
            protocolsSet,
            gasModel,
            routesWithValidQuotesByProtocol,
            allRoutesWithValidQuotes,
            allCandidatePools,
            _iterator,
            _step,
            _step$value,
            routesWithValidQuotes,
            candidatePools,
            beforeBestSwap,
            swapRouteRaw,
            quote,
            quoteGasAdjusted,
            estimatedGasUsed,
            routeAmounts,
            estimatedGasUsedQuoteToken,
            estimatedGasUsedUSD,
            trade,
            methodParameters,
            _args3 = arguments;

        return _regeneratorRuntime().wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                partialRoutingConfig = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : {};
                metric.putMetric("QuoteRequestedForChain".concat(this.chainId), 1, MetricLoggerUnit.Count); // Get a block number to specify in all our calls. Ensures data we fetch from chain is
                // from the same block.

                blockNumber = (_a = partialRoutingConfig.blockNumber) !== null && _a !== void 0 ? _a : this.getBlockNumberPromise();
                routingConfig = _.merge({}, DEFAULT_ROUTING_CONFIG_BY_CHAIN(this.chainId), partialRoutingConfig, {
                  blockNumber: blockNumber
                });
                protocols = routingConfig.protocols;
                currencyIn = tradeType == TradeType.EXACT_INPUT ? amount.currency : quoteCurrency;
                currencyOut = tradeType == TradeType.EXACT_INPUT ? quoteCurrency : amount.currency;
                tokenIn = currencyIn.wrapped;
                tokenOut = currencyOut.wrapped; // Generate our distribution of amounts, i.e. fractions of the input amount.
                // We will get quotes for fractions of the input amount for different routes, then
                // combine to generate split routes.

                _this$getAmountDistri = this.getAmountDistribution(amount, routingConfig), _this$getAmountDistri2 = _slicedToArray(_this$getAmountDistri, 2), percents = _this$getAmountDistri2[0], amounts = _this$getAmountDistri2[1]; // Get an estimate of the gas price to use when estimating gas cost of different routes.

                beforeGas = Date.now();
                _context3.next = 13;
                return this.gasPriceProvider.getGasPrice();

              case 13:
                _yield$this$gasPriceP = _context3.sent;
                gasPriceWei = _yield$this$gasPriceP.gasPriceWei;
                metric.putMetric('GasPriceLoad', Date.now() - beforeGas, MetricLoggerUnit.Milliseconds);
                quoteToken = quoteCurrency.wrapped;
                quotePromises = [];
                protocolsSet = new Set(protocols !== null && protocols !== void 0 ? protocols : []);
                _context3.next = 21;
                return this.v3GasModelFactory.buildGasModel(this.chainId, gasPriceWei, this.v3PoolProvider, quoteToken, this.l2GasDataProvider);

              case 21:
                gasModel = _context3.sent;

                if ((protocolsSet.size == 0 || protocolsSet.has(Protocol.V2) && protocolsSet.has(Protocol.V3)) && V2_SUPPORTED.includes(this.chainId)) {
                  log.info({
                    protocols: protocols,
                    tradeType: tradeType
                  }, 'Routing across all protocols');
                  quotePromises.push(this.getV3Quotes(tokenIn, tokenOut, amounts, percents, quoteToken, gasModel, tradeType, routingConfig));
                  quotePromises.push(this.getV2Quotes(tokenIn, tokenOut, amounts, percents, quoteToken, gasPriceWei, tradeType, routingConfig));
                } else {
                  if (protocolsSet.has(Protocol.V3) || protocolsSet.size == 0 && !V2_SUPPORTED.includes(this.chainId)) {
                    log.info({
                      protocols: protocols,
                      swapType: tradeType
                    }, 'Routing across V3');
                    quotePromises.push(this.getV3Quotes(tokenIn, tokenOut, amounts, percents, quoteToken, gasModel, tradeType, routingConfig));
                  }

                  if (protocolsSet.has(Protocol.V2)) {
                    log.info({
                      protocols: protocols,
                      swapType: tradeType
                    }, 'Routing across V2');
                    quotePromises.push(this.getV2Quotes(tokenIn, tokenOut, amounts, percents, quoteToken, gasPriceWei, tradeType, routingConfig));
                  }
                }

                _context3.next = 25;
                return Promise.all(quotePromises);

              case 25:
                routesWithValidQuotesByProtocol = _context3.sent;
                allRoutesWithValidQuotes = [];
                allCandidatePools = [];
                _iterator = _createForOfIteratorHelper(routesWithValidQuotesByProtocol);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = _step.value, routesWithValidQuotes = _step$value.routesWithValidQuotes, candidatePools = _step$value.candidatePools;
                    allRoutesWithValidQuotes = [].concat(_toConsumableArray(allRoutesWithValidQuotes), _toConsumableArray(routesWithValidQuotes));
                    allCandidatePools = [].concat(_toConsumableArray(allCandidatePools), [candidatePools]);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                if (!(allRoutesWithValidQuotes.length == 0)) {
                  _context3.next = 33;
                  break;
                }

                log.info({
                  allRoutesWithValidQuotes: allRoutesWithValidQuotes
                }, 'Received no valid quotes');
                return _context3.abrupt("return", null);

              case 33:
                // Given all the quotes for all the amounts for all the routes, find the best combination.
                beforeBestSwap = Date.now();
                _context3.next = 36;
                return getBestSwapRoute(amount, percents, allRoutesWithValidQuotes, tradeType, this.chainId, routingConfig, gasModel);

              case 36:
                swapRouteRaw = _context3.sent;

                if (swapRouteRaw) {
                  _context3.next = 39;
                  break;
                }

                return _context3.abrupt("return", null);

              case 39:
                quote = swapRouteRaw.quote, quoteGasAdjusted = swapRouteRaw.quoteGasAdjusted, estimatedGasUsed = swapRouteRaw.estimatedGasUsed, routeAmounts = swapRouteRaw.routes, estimatedGasUsedQuoteToken = swapRouteRaw.estimatedGasUsedQuoteToken, estimatedGasUsedUSD = swapRouteRaw.estimatedGasUsedUSD; // Build Trade object that represents the optimal swap.

                trade = buildTrade(currencyIn, currencyOut, tradeType, routeAmounts);

                // If user provided recipient, deadline etc. we also generate the calldata required to execute
                // the swap and return it too.
                if (swapConfig) {
                  methodParameters = buildSwapMethodParameters(trade, swapConfig);
                }

                metric.putMetric('FindBestSwapRoute', Date.now() - beforeBestSwap, MetricLoggerUnit.Milliseconds);
                metric.putMetric("QuoteFoundForChain".concat(this.chainId), 1, MetricLoggerUnit.Count);
                this.emitPoolSelectionMetrics(swapRouteRaw, allCandidatePools);
                _context3.t0 = quote;
                _context3.t1 = quoteGasAdjusted;
                _context3.t2 = estimatedGasUsed;
                _context3.t3 = estimatedGasUsedQuoteToken;
                _context3.t4 = estimatedGasUsedUSD;
                _context3.t5 = gasPriceWei;
                _context3.t6 = routeAmounts;
                _context3.t7 = trade;
                _context3.t8 = methodParameters;
                _context3.t9 = BigNumber;
                _context3.next = 57;
                return blockNumber;

              case 57:
                _context3.t10 = _context3.sent;
                _context3.t11 = _context3.t9.from.call(_context3.t9, _context3.t10);
                return _context3.abrupt("return", {
                  quote: _context3.t0,
                  quoteGasAdjusted: _context3.t1,
                  estimatedGasUsed: _context3.t2,
                  estimatedGasUsedQuoteToken: _context3.t3,
                  estimatedGasUsedUSD: _context3.t4,
                  gasPriceWei: _context3.t5,
                  route: _context3.t6,
                  trade: _context3.t7,
                  methodParameters: _context3.t8,
                  blockNumber: _context3.t11
                });

              case 60:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function route(_x6, _x7, _x8, _x9) {
        return _route.apply(this, arguments);
      }

      return route;
    }()
  }, {
    key: "applyTokenValidatorToPools",
    value: function () {
      var _applyTokenValidatorToPools = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(pools, isInvalidFn) {
        var tokens, tokenValidationResults, poolsFiltered;
        return _regeneratorRuntime().wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.tokenValidatorProvider) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", pools);

              case 2:
                log.info("Running token validator on ".concat(pools.length, " pools"));
                tokens = _.flatMap(pools, function (pool) {
                  return [pool.token0, pool.token1];
                });
                _context4.next = 6;
                return this.tokenValidatorProvider.validateTokens(tokens);

              case 6:
                tokenValidationResults = _context4.sent;
                poolsFiltered = _.filter(pools, function (pool) {
                  var token0Validation = tokenValidationResults.getValidationByToken(pool.token0);
                  var token1Validation = tokenValidationResults.getValidationByToken(pool.token1);
                  var token0Invalid = isInvalidFn(pool.token0, token0Validation);
                  var token1Invalid = isInvalidFn(pool.token1, token1Validation);

                  if (token0Invalid || token1Invalid) {
                    log.info("Dropping pool ".concat(poolToString(pool), " because token is invalid. ").concat(pool.token0.symbol, ": ").concat(token0Validation, ", ").concat(pool.token1.symbol, ": ").concat(token1Validation));
                  }

                  return !token0Invalid && !token1Invalid;
                });
                return _context4.abrupt("return", poolsFiltered);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3, this);
      }));

      function applyTokenValidatorToPools(_x10, _x11) {
        return _applyTokenValidatorToPools.apply(this, arguments);
      }

      return applyTokenValidatorToPools;
    }()
  }, {
    key: "getV3Quotes",
    value: function () {
      var _getV3Quotes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(tokenIn, tokenOut, amounts, percents, quoteToken, gasModel, swapType, routingConfig) {
        var _yield$getV3Candidate, poolAccessor, candidatePools, poolsRaw, pools, maxSwapsPerPath, routes, quoteFn, beforeQuotes, _yield$quoteFn, routesWithQuotes, routesWithValidQuotes, _iterator2, _step2, routeWithQuote, _routeWithQuote, route, quotes, i, percent, amountQuote, quote, amount, sqrtPriceX96AfterList, initializedTicksCrossedList, gasEstimate, routeWithValidQuote;

        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                log.info('Starting to get V3 quotes'); // Fetch all the pools that we will consider routing via. There are thousands
                // of pools, so we filter them to a set of candidate pools that we expect will
                // result in good prices.

                _context5.next = 3;
                return getV3CandidatePools({
                  tokenIn: tokenIn,
                  tokenOut: tokenOut,
                  tokenProvider: this.tokenProvider,
                  blockedTokenListProvider: this.blockedTokenListProvider,
                  poolProvider: this.v3PoolProvider,
                  routeType: swapType,
                  subgraphProvider: this.v3SubgraphProvider,
                  routingConfig: routingConfig,
                  chainId: this.chainId
                });

              case 3:
                _yield$getV3Candidate = _context5.sent;
                poolAccessor = _yield$getV3Candidate.poolAccessor;
                candidatePools = _yield$getV3Candidate.candidatePools;
                poolsRaw = poolAccessor.getAllPools(); // Drop any pools that contain fee on transfer tokens (not supported by v3) or have issues with being transferred.

                _context5.next = 9;
                return this.applyTokenValidatorToPools(poolsRaw, function (token, tokenValidation) {
                  // If there is no available validation result we assume the token is fine.
                  if (!tokenValidation) {
                    return false;
                  } // Only filters out *intermediate* pools that involve tokens that we detect
                  // cant be transferred. This prevents us trying to route through tokens that may
                  // not be transferrable, but allows users to still swap those tokens if they
                  // specify.
                  //


                  if (tokenValidation == TokenValidationResult.STF && (token.equals(tokenIn) || token.equals(tokenOut))) {
                    return false;
                  }

                  return tokenValidation == TokenValidationResult.FOT || tokenValidation == TokenValidationResult.STF;
                });

              case 9:
                pools = _context5.sent;
                // Given all our candidate pools, compute all the possible ways to route from tokenIn to tokenOut.
                maxSwapsPerPath = routingConfig.maxSwapsPerPath;
                routes = computeAllV3Routes(tokenIn, tokenOut, pools, maxSwapsPerPath);

                if (!(routes.length == 0)) {
                  _context5.next = 14;
                  break;
                }

                return _context5.abrupt("return", {
                  routesWithValidQuotes: [],
                  candidatePools: candidatePools
                });

              case 14:
                // For all our routes, and all the fractional amounts, fetch quotes on-chain.
                quoteFn = swapType == TradeType.EXACT_INPUT ? this.v3QuoteProvider.getQuotesManyExactIn.bind(this.v3QuoteProvider) : this.v3QuoteProvider.getQuotesManyExactOut.bind(this.v3QuoteProvider);
                beforeQuotes = Date.now();
                log.info("Getting quotes for V3 for ".concat(routes.length, " routes with ").concat(amounts.length, " amounts per route."));
                _context5.next = 19;
                return quoteFn(amounts, routes, {
                  blockNumber: routingConfig.blockNumber
                });

              case 19:
                _yield$quoteFn = _context5.sent;
                routesWithQuotes = _yield$quoteFn.routesWithQuotes;
                metric.putMetric('V3QuotesLoad', Date.now() - beforeQuotes, MetricLoggerUnit.Milliseconds);
                metric.putMetric('V3QuotesFetched', _(routesWithQuotes).map(function (_ref5) {
                  var _ref6 = _slicedToArray(_ref5, 2),
                      quotes = _ref6[1];

                  return quotes.length;
                }).sum(), MetricLoggerUnit.Count);
                routesWithValidQuotes = [];
                _iterator2 = _createForOfIteratorHelper(routesWithQuotes);
                _context5.prev = 25;

                _iterator2.s();

              case 27:
                if ((_step2 = _iterator2.n()).done) {
                  _context5.next = 45;
                  break;
                }

                routeWithQuote = _step2.value;
                _routeWithQuote = _slicedToArray(routeWithQuote, 2), route = _routeWithQuote[0], quotes = _routeWithQuote[1];
                i = 0;

              case 31:
                if (!(i < quotes.length)) {
                  _context5.next = 43;
                  break;
                }

                percent = percents[i];
                amountQuote = quotes[i];
                quote = amountQuote.quote, amount = amountQuote.amount, sqrtPriceX96AfterList = amountQuote.sqrtPriceX96AfterList, initializedTicksCrossedList = amountQuote.initializedTicksCrossedList, gasEstimate = amountQuote.gasEstimate;

                if (!(!quote || !sqrtPriceX96AfterList || !initializedTicksCrossedList || !gasEstimate)) {
                  _context5.next = 38;
                  break;
                }

                log.debug({
                  route: routeToString(route),
                  amountQuote: amountQuote
                }, 'Dropping a null V3 quote for route.');
                return _context5.abrupt("continue", 40);

              case 38:
                routeWithValidQuote = new V3RouteWithValidQuote({
                  route: route,
                  rawQuote: quote,
                  amount: amount,
                  percent: percent,
                  sqrtPriceX96AfterList: sqrtPriceX96AfterList,
                  initializedTicksCrossedList: initializedTicksCrossedList,
                  quoterGasEstimate: gasEstimate,
                  gasModel: gasModel,
                  quoteToken: quoteToken,
                  tradeType: swapType,
                  v3PoolProvider: this.v3PoolProvider
                });
                routesWithValidQuotes.push(routeWithValidQuote);

              case 40:
                i++;
                _context5.next = 31;
                break;

              case 43:
                _context5.next = 27;
                break;

              case 45:
                _context5.next = 50;
                break;

              case 47:
                _context5.prev = 47;
                _context5.t0 = _context5["catch"](25);

                _iterator2.e(_context5.t0);

              case 50:
                _context5.prev = 50;

                _iterator2.f();

                return _context5.finish(50);

              case 53:
                return _context5.abrupt("return", {
                  routesWithValidQuotes: routesWithValidQuotes,
                  candidatePools: candidatePools
                });

              case 54:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, this, [[25, 47, 50, 53]]);
      }));

      function getV3Quotes(_x12, _x13, _x14, _x15, _x16, _x17, _x18, _x19) {
        return _getV3Quotes.apply(this, arguments);
      }

      return getV3Quotes;
    }()
  }, {
    key: "getV2Quotes",
    value: function () {
      var _getV2Quotes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(tokenIn, tokenOut, amounts, percents, quoteToken, gasPriceWei, swapType, routingConfig) {
        var _yield$getV2Candidate, poolAccessor, candidatePools, poolsRaw, pools, maxSwapsPerPath, routes, quoteFn, beforeQuotes, _yield$quoteFn2, routesWithQuotes, gasModel, routesWithValidQuotes, _iterator3, _step3, routeWithQuote, _routeWithQuote2, route, quotes, i, percent, amountQuote, quote, amount, routeWithValidQuote;

        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                log.info('Starting to get V2 quotes'); // Fetch all the pools that we will consider routing via. There are thousands
                // of pools, so we filter them to a set of candidate pools that we expect will
                // result in good prices.

                _context6.next = 3;
                return getV2CandidatePools({
                  tokenIn: tokenIn,
                  tokenOut: tokenOut,
                  tokenProvider: this.tokenProvider,
                  blockedTokenListProvider: this.blockedTokenListProvider,
                  poolProvider: this.v2PoolProvider,
                  routeType: swapType,
                  subgraphProvider: this.v2SubgraphProvider,
                  routingConfig: routingConfig,
                  chainId: this.chainId
                });

              case 3:
                _yield$getV2Candidate = _context6.sent;
                poolAccessor = _yield$getV2Candidate.poolAccessor;
                candidatePools = _yield$getV2Candidate.candidatePools;
                poolsRaw = poolAccessor.getAllPools(); // Drop any pools that contain tokens that can not be transferred according to the token validator.

                _context6.next = 9;
                return this.applyTokenValidatorToPools(poolsRaw, function (token, tokenValidation) {
                  // If there is no available validation result we assume the token is fine.
                  if (!tokenValidation) {
                    return false;
                  } // Only filters out *intermediate* pools that involve tokens that we detect
                  // cant be transferred. This prevents us trying to route through tokens that may
                  // not be transferrable, but allows users to still swap those tokens if they
                  // specify.


                  if (tokenValidation == TokenValidationResult.STF && (token.equals(tokenIn) || token.equals(tokenOut))) {
                    return false;
                  }

                  return tokenValidation == TokenValidationResult.STF;
                });

              case 9:
                pools = _context6.sent;
                // Given all our candidate pools, compute all the possible ways to route from tokenIn to tokenOut.
                maxSwapsPerPath = routingConfig.maxSwapsPerPath;
                routes = computeAllV2Routes(tokenIn, tokenOut, pools, maxSwapsPerPath);

                if (!(routes.length == 0)) {
                  _context6.next = 14;
                  break;
                }

                return _context6.abrupt("return", {
                  routesWithValidQuotes: [],
                  candidatePools: candidatePools
                });

              case 14:
                // For all our routes, and all the fractional amounts, fetch quotes on-chain.
                quoteFn = swapType == TradeType.EXACT_INPUT ? this.v2QuoteProvider.getQuotesManyExactIn.bind(this.v2QuoteProvider) : this.v2QuoteProvider.getQuotesManyExactOut.bind(this.v2QuoteProvider);
                beforeQuotes = Date.now();
                log.info("Getting quotes for V2 for ".concat(routes.length, " routes with ").concat(amounts.length, " amounts per route."));
                _context6.next = 19;
                return quoteFn(amounts, routes);

              case 19:
                _yield$quoteFn2 = _context6.sent;
                routesWithQuotes = _yield$quoteFn2.routesWithQuotes;
                _context6.next = 23;
                return this.v2GasModelFactory.buildGasModel(this.chainId, gasPriceWei, this.v2PoolProvider, quoteToken);

              case 23:
                gasModel = _context6.sent;
                metric.putMetric('V2QuotesLoad', Date.now() - beforeQuotes, MetricLoggerUnit.Milliseconds);
                metric.putMetric('V2QuotesFetched', _(routesWithQuotes).map(function (_ref7) {
                  var _ref8 = _slicedToArray(_ref7, 2),
                      quotes = _ref8[1];

                  return quotes.length;
                }).sum(), MetricLoggerUnit.Count);
                routesWithValidQuotes = [];
                _iterator3 = _createForOfIteratorHelper(routesWithQuotes);
                _context6.prev = 28;

                _iterator3.s();

              case 30:
                if ((_step3 = _iterator3.n()).done) {
                  _context6.next = 48;
                  break;
                }

                routeWithQuote = _step3.value;
                _routeWithQuote2 = _slicedToArray(routeWithQuote, 2), route = _routeWithQuote2[0], quotes = _routeWithQuote2[1];
                i = 0;

              case 34:
                if (!(i < quotes.length)) {
                  _context6.next = 46;
                  break;
                }

                percent = percents[i];
                amountQuote = quotes[i];
                quote = amountQuote.quote, amount = amountQuote.amount;

                if (quote) {
                  _context6.next = 41;
                  break;
                }

                log.debug({
                  route: routeToString(route),
                  amountQuote: amountQuote
                }, 'Dropping a null V2 quote for route.');
                return _context6.abrupt("continue", 43);

              case 41:
                routeWithValidQuote = new V2RouteWithValidQuote({
                  route: route,
                  rawQuote: quote,
                  amount: amount,
                  percent: percent,
                  gasModel: gasModel,
                  quoteToken: quoteToken,
                  tradeType: swapType,
                  v2PoolProvider: this.v2PoolProvider
                });
                routesWithValidQuotes.push(routeWithValidQuote);

              case 43:
                i++;
                _context6.next = 34;
                break;

              case 46:
                _context6.next = 30;
                break;

              case 48:
                _context6.next = 53;
                break;

              case 50:
                _context6.prev = 50;
                _context6.t0 = _context6["catch"](28);

                _iterator3.e(_context6.t0);

              case 53:
                _context6.prev = 53;

                _iterator3.f();

                return _context6.finish(53);

              case 56:
                return _context6.abrupt("return", {
                  routesWithValidQuotes: routesWithValidQuotes,
                  candidatePools: candidatePools
                });

              case 57:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this, [[28, 50, 53, 56]]);
      }));

      function getV2Quotes(_x20, _x21, _x22, _x23, _x24, _x25, _x26, _x27) {
        return _getV2Quotes.apply(this, arguments);
      }

      return getV2Quotes;
    }() // Note multiplications here can result in a loss of precision in the amounts (e.g. taking 50% of 101)
    // This is reconcilled at the end of the algorithm by adding any lost precision to one of
    // the splits in the route.

  }, {
    key: "getAmountDistribution",
    value: function getAmountDistribution(amount, routingConfig) {
      var distributionPercent = routingConfig.distributionPercent;
      var percents = [];
      var amounts = [];

      for (var i = 1; i <= 100 / distributionPercent; i++) {
        percents.push(i * distributionPercent);
        amounts.push(amount.multiply(new Fraction(i * distributionPercent, 100)));
      }

      return [percents, amounts];
    }
  }, {
    key: "buildSwapAndAddMethodParameters",
    value: function () {
      var _buildSwapAndAddMethodParameters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(trade, swapAndAddOptions, swapAndAddParameters) {
        var _swapAndAddOptions$sw, recipient, slippageTolerance, deadline, inputTokenPermit, addLiquidityConfig, preLiquidityPosition, finalBalanceTokenIn, finalBalanceTokenOut, approvalTypes, zeroForOne;

        return _regeneratorRuntime().wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _swapAndAddOptions$sw = swapAndAddOptions.swapOptions, recipient = _swapAndAddOptions$sw.recipient, slippageTolerance = _swapAndAddOptions$sw.slippageTolerance, deadline = _swapAndAddOptions$sw.deadline, inputTokenPermit = _swapAndAddOptions$sw.inputTokenPermit, addLiquidityConfig = swapAndAddOptions.addLiquidityOptions;
                preLiquidityPosition = swapAndAddParameters.preLiquidityPosition;
                finalBalanceTokenIn = swapAndAddParameters.initialBalanceTokenIn.subtract(trade.inputAmount);
                finalBalanceTokenOut = swapAndAddParameters.initialBalanceTokenOut.add(trade.outputAmount);
                _context7.next = 6;
                return this.swapRouterProvider.getApprovalType(finalBalanceTokenIn, finalBalanceTokenOut);

              case 6:
                approvalTypes = _context7.sent;
                zeroForOne = finalBalanceTokenIn.currency.wrapped.sortsBefore(finalBalanceTokenOut.currency.wrapped);
                return _context7.abrupt("return", SwapRouter.swapAndAddCallParameters(trade, {
                  recipient: recipient,
                  slippageTolerance: slippageTolerance,
                  deadlineOrPreviousBlockhash: deadline,
                  inputTokenPermit: inputTokenPermit
                }, Position.fromAmounts({
                  pool: preLiquidityPosition.pool,
                  tickLower: preLiquidityPosition.tickLower,
                  tickUpper: preLiquidityPosition.tickUpper,
                  amount0: zeroForOne ? finalBalanceTokenIn.quotient.toString() : finalBalanceTokenOut.quotient.toString(),
                  amount1: zeroForOne ? finalBalanceTokenOut.quotient.toString() : finalBalanceTokenIn.quotient.toString(),
                  useFullPrecision: false
                }), addLiquidityConfig, approvalTypes.approvalTokenIn, approvalTypes.approvalTokenOut));

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, this);
      }));

      function buildSwapAndAddMethodParameters(_x28, _x29, _x30) {
        return _buildSwapAndAddMethodParameters.apply(this, arguments);
      }

      return buildSwapAndAddMethodParameters;
    }()
  }, {
    key: "emitPoolSelectionMetrics",
    value: function emitPoolSelectionMetrics(swapRouteRaw, allPoolsBySelection) {
      var poolAddressesUsed = new Set();
      var routeAmounts = swapRouteRaw.routes;

      _(routeAmounts).flatMap(function (routeAmount) {
        var poolAddresses = routeAmount.poolAddresses;
        return poolAddresses;
      }).forEach(function (address) {
        poolAddressesUsed.add(address.toLowerCase());
      });

      var _iterator4 = _createForOfIteratorHelper(allPoolsBySelection),
          _step4;

      try {
        var _loop2 = function _loop2() {
          var poolsBySelection = _step4.value;
          var protocol = poolsBySelection.protocol;

          _.forIn(poolsBySelection.selections, function (pools, topNSelection) {
            var topNUsed = _.findLastIndex(pools, function (pool) {
              return poolAddressesUsed.has(pool.id.toLowerCase());
            }) + 1;
            metric.putMetric(_.capitalize("".concat(protocol).concat(topNSelection)), topNUsed, MetricLoggerUnit.Count);
          });
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var hasV3Route = false;
      var hasV2Route = false;

      var _iterator5 = _createForOfIteratorHelper(routeAmounts),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var routeAmount = _step5.value;

          if (routeAmount.protocol == Protocol.V3) {
            hasV3Route = true;
          }

          if (routeAmount.protocol == Protocol.V2) {
            hasV2Route = true;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (hasV3Route && hasV2Route) {
        metric.putMetric("V3AndV2SplitRoute", 1, MetricLoggerUnit.Count);
        metric.putMetric("V3AndV2SplitRouteForChain".concat(this.chainId), 1, MetricLoggerUnit.Count);
      } else if (hasV3Route) {
        if (routeAmounts.length > 1) {
          metric.putMetric("V3SplitRoute", 1, MetricLoggerUnit.Count);
          metric.putMetric("V3SplitRouteForChain".concat(this.chainId), 1, MetricLoggerUnit.Count);
        } else {
          metric.putMetric("V3Route", 1, MetricLoggerUnit.Count);
          metric.putMetric("V3RouteForChain".concat(this.chainId), 1, MetricLoggerUnit.Count);
        }
      } else if (hasV2Route) {
        if (routeAmounts.length > 1) {
          metric.putMetric("V2SplitRoute", 1, MetricLoggerUnit.Count);
          metric.putMetric("V2SplitRouteForChain".concat(this.chainId), 1, MetricLoggerUnit.Count);
        } else {
          metric.putMetric("V2Route", 1, MetricLoggerUnit.Count);
          metric.putMetric("V2RouteForChain".concat(this.chainId), 1, MetricLoggerUnit.Count);
        }
      }
    }
  }, {
    key: "calculateOptimalRatio",
    value: function calculateOptimalRatio(position, sqrtRatioX96, zeroForOne) {
      var upperSqrtRatioX96 = TickMath.getSqrtRatioAtTick(position.tickUpper);
      var lowerSqrtRatioX96 = TickMath.getSqrtRatioAtTick(position.tickLower); // returns Fraction(0, 1) for any out of range position regardless of zeroForOne. Implication: function
      // cannot be used to determine the trading direction of out of range positions.

      if (JSBI.greaterThan(sqrtRatioX96, upperSqrtRatioX96) || JSBI.lessThan(sqrtRatioX96, lowerSqrtRatioX96)) {
        return new Fraction(0, 1);
      }

      var precision = JSBI.BigInt('1' + '0'.repeat(18));
      var optimalRatio = new Fraction(SqrtPriceMath.getAmount0Delta(sqrtRatioX96, upperSqrtRatioX96, precision, true), SqrtPriceMath.getAmount1Delta(sqrtRatioX96, lowerSqrtRatioX96, precision, true));
      if (!zeroForOne) optimalRatio = optimalRatio.invert();
      return optimalRatio;
    }
  }, {
    key: "absoluteValue",
    value: function absoluteValue(fraction) {
      var numeratorAbs = JSBI.lessThan(fraction.numerator, JSBI.BigInt(0)) ? JSBI.unaryMinus(fraction.numerator) : fraction.numerator;
      var denominatorAbs = JSBI.lessThan(fraction.denominator, JSBI.BigInt(0)) ? JSBI.unaryMinus(fraction.denominator) : fraction.denominator;
      return new Fraction(numeratorAbs, denominatorAbs);
    }
  }, {
    key: "getBlockNumberPromise",
    value: function getBlockNumberPromise() {
      var _this2 = this;

      return retry( /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_b, attempt) {
          return _regeneratorRuntime().wrap(function _callee7$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (attempt > 1) {
                    log.info("Get block number attempt ".concat(attempt));
                  }

                  return _context8.abrupt("return", _this2.provider.getBlockNumber());

                case 2:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x31, _x32) {
          return _ref9.apply(this, arguments);
        };
      }(), {
        retries: 2,
        minTimeout: 100,
        maxTimeout: 1000
      });
    }
  }]);

  return AlphaRouter;
}();